<template>
  <div
    class="menu"
    :style="
      display.device === 'Desktop'
        ? 'height: ' + (display.height - 130) + 'px; '
        : 'height: ' + display.height + 'px; '
    "
  >
    <v-container fill-height>
      <v-row align="center" justify="center">
        <!-- <v-col v-for="n in 5" :key="n" class="text-center" lg="3" md="4" sm="6" cols="6">
    
            </v-col> -->

        <v-col lg="2" md="4" sm="3" cols="3">
          <v-card elevation="6">
            <v-container fluid>
              <v-row justify="center" align="center" @click="searchForSales()">
                <v-col class="text-center">
                  <h3>ค้นหาสินค้าจาก BOQ</h3>

                  <v-img
                    lazy-src="../assets/img_www/icon-boq.png"
                    src="../assets/img_www/icon-boq.png"
                  >
                  </v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col lg="2" md="4" sm="3" cols="3">
          <v-card elevation="6">
            <v-container fluid>
              <v-row justify="center" align="center" @click="showpoint()">
                <v-col class="text-center">
                  <h1>ตรวจสอบคะเเนนลูกค้า</h1>

                  <v-img
                    lazy-src="../assets/img_www/icon-point.png"
                    src="../assets/img_www/icon-point.png"
                  >
                  </v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col lg="2" md="4" sm="3" cols="3">
          <v-card elevation="6">
            <v-container fluid>
              <v-row justify="center" align="center" @click="logOut()">
                <v-col class="text-center">
                  <h3>ออกจากระบบ</h3>

                  <v-img
                    lazy-src="../assets/img_www/icon-log-out.png"
                    src="../assets/img_www/icon-log-out.png"
                  >
                  </v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="details" scrollable max-width="60%">
      <v-card>
        <v-card-title>ตรวจสอบคะเเนนลูกค้า</v-card-title>
        <v-divider></v-divider>
        <v-row align="center" justify="center" class="pt-4 pb-4">
          <v-col class="text-center pb-0" lg="10" md="10" sm="10" cols="10">
            <v-form v-model="search.valid" v-on:submit.prevent="searchFn()">
              <v-text-field
                v-model.trim="search.keyword"
                dense
                placeholder="กรุณาใส่รายชื่อที่ต้องการจะค้นหา"
                outlined
                :rules="search.keyword_rules"
                hide-details="auto"
                append-icon="mdi-magnify"
                @click:append="searchFn()"
              >
              </v-text-field>
            </v-form>
          </v-col>
        </v-row>

        <v-card-text style="height: 70%;">
          <v-radio-group
            v-model="dialogm1"
            column
            v-for="(arname, index) in arnames"
            :key="index"
          >
            <v-card class="mx-auto" color="#BB0000" dark width="90%">
              <v-card-actions>
                <v-list-item class="grow">
                  <v-row>
                    <v-col class="text-center pb-0" lg="1" md="1" sm="1" cols="1">
                      <v-list-item-avatar color="grey darken-3">
                        <v-img
                          class="elevation-6"
                          alt=""
                          src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                        ></v-img>
                      </v-list-item-avatar>
                    </v-col>
                    <v-col lg="9" md="9" sm="9" cols="9" align="left">
                      <v-list-item-content>
                        <p class="text-h5 color=rgb " >{{
                          arname.arname
                        }}</p>
                      </v-list-item-content>
                    </v-col>
                    <v-col class="text-center pb-0" lg="2" md="2" sm="2" cols="2" align="center" justify="end">
                      <v-icon class="mr-1">
                        mdi-heart
                      </v-icon>
                      <span class="text-h5 color=rgb ">{{
                        arname.hml_point
                      }}</span>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-card-actions>
            </v-card>
          </v-radio-group>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="#CC0000" text @click="details = false">
            ปิดหน้าจอ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoadding" max-width="400" persistent>
      <v-card elevation="12">
        <v-card-text>
          <v-container fluid>
            <v-row justify="center" align="center">
              <v-col class="text-center">
                <lottie-player
                  src="https://assets4.lottiefiles.com/packages/lf20_h59xofz0.json"
                  background="transparent"
                  speed="1"
                  loop
                  autoplay
                ></lottie-player>

                <h2>กำลังโหลดข้อมูล ...</h2>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Menubox",
  data: () => ({
    dialogm1: "",
    isLoadding: false,
    reveal: false,
    arnames: [],
    details: false,
    search: {
      keyword: "",
      valid: false,
      keyword_rules: [(v) => !!v || "กรุณาใส่คำที่จะค้นหา"],
    },
    display: {
      height: 0,
      width: 0,
      device: null,
    },
    snackbar: {
      show: false,
      message: "",
    },
    form: {
      arname: "",
      hml_point: "",
    },
  }),
  created() {
    this.checkDisplay();
    this.checkDevice();
  },
  mounted() {
    if (localStorage.getItem("username") !== null) {
      //----------
    }
  },
  methods: {
    searchFn() {
      this.$session.set("hml_portal_search_word", this.search.keyword);
      this.isLoadding = true;
      this.gitpoint();
    },

    gitpoint() {
      axios
        .post(this.api + "/check-point", {
          arname: this.$session.get("hml_portal_search_word"),
        })
        .then((res) => {
          if (res.data.status) {
            this.isLoadding = false;
            this.arnames = res.data.response;
          } else {
            alert(res.data.error);
          }
        });
    },
    searchForSales() {
      this.$router.push("/search-for-sales");
    },
    showpoint() {
      this.details = true;
    },
    logOut() {
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("role");
      this.$router.push("/");
    },
    checkDevice() {
      const ua = navigator.userAgent;
      if (
        /(tablet|ipad|playbook|silk|macintosh)|(android(?!.*mobi))/i.test(ua)
      ) {
        this.display.device = "Tablet";
      } else if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        this.display.device = "Mobile";
      } else {
        this.display.device = "Desktop";
      }
    },
    checkDisplay() {
      this.display.height = screen.height;
      this.display.width = screen.width;
    },
  },
};
</script>

<style>
.menu {
  background-image: url("http://www.kmppartners.info/watsaduonline_management/images/background2.png") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
